/**
 * MD-14 FE-LANDINGS - i18n contract
 *
 * Each landing has a typed key set; CI typecheck enforces every key is
 * present in both lang catalogs (or marked VN-only via `VN_ONLY` sentinel).
 *
 * Reference:
 *   - F-FE-LANDINGS.md Sec.11 AC-11 i18n key coverage 100%
 *   - F-FE-LANDINGS.md Sec.5 i18n missing key fallback chain
 */

export type LandingSlug = 'universal' | 'expat' | 'sme' | 'citizen';
export type Lang = 'vi' | 'en';

export type LandingCopy = {
  meta_title: string;
  meta_description: string;
  hero_eyebrow: string;
  hero_headline: string;
  hero_subhead: string;
  cta_primary: string;
  cta_secondary: string;
  feature_1_title: string;
  feature_1_body: string;
  feature_2_title: string;
  feature_2_body: string;
  feature_3_title: string;
  feature_3_body: string;
  pricing_intro: string;
  footer_disclaimer: string;
};

/** Sentinel for keys intentionally absent in EN (citizen segment is VN-only). */
export const VN_ONLY = '__VN_ONLY__' as const;
export type MaybeVN = string | typeof VN_ONLY;

export type LandingCatalog<L extends Lang> = L extends 'vi'
  ? LandingCopy
  : { [K in keyof LandingCopy]: MaybeVN };
